import { defineModel } from "../define-model";

export type Insight = {
	id: string;
	workspaceId: string;
	projectId: string;
	kind: "performance" | "competitor" | "strategy_review";
	subjectType: string | null;
	subjectId: string | null;
	periodStart: string | null;
	periodEnd: string | null;
	summary: string;
	learnings: { pattern: string; evidence: string[]; confidence: number }[];
	recommendations: string[];
	model: string | null;
	generationId: string | null;
	costUsd: number;
	millicredits: number;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		insight: Insight;
	}
}

export const model = defineModel({
	name: "insight",
	load: "lazy",
	indexes: ["projectId"],
	sort: (a, b) => b.createdAt.localeCompare(a.createdAt),
});
